module.exports = __webpack_public_path__ + "img/ClashofClansLogoMinimal.bea021b1.png";